module.exports = __webpack_public_path__ + "static/media/screen5.b4d6083e.png";